export interface EnrollResponse {
  device_id: string;
  fingerprint: string;
  status: string;
}

export interface StatusResponse {
  device_id: string;
  status: string;
  fingerprint: string;
}

export interface ActivateResponse {
  device_id: string;
  conversation_id: string;
  status: string;
  device_jwt: string;
  owner_identity_public_key: string;
  owner_ephemeral_public_key: string | null;
}

export async function enrollDevice(
  apiUrl: string,
  inviteToken: string,
  identityPkHex: string,
  ephemeralPkHex: string,
  proofHex: string,
  platform?: string,
  expectedFramework?: string,
): Promise<EnrollResponse> {
  const res = await fetch(`${apiUrl}/api/v1/enroll`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      invite_token: inviteToken,
      identity_public_key: identityPkHex,
      ephemeral_public_key: ephemeralPkHex,
      proof_of_possession: proofHex,
      platform: platform ?? "node",
      ...(expectedFramework ? { expected_framework: expectedFramework } : {}),
    }),
  });
  if (!res.ok) {
    const detail = await res.text();
    throw new Error(`Enrollment failed (${res.status}): ${detail}`);
  }
  return res.json();
}

export async function pollDeviceStatus(
  apiUrl: string,
  deviceId: string,
): Promise<StatusResponse & { rateLimited?: boolean }> {
  const res = await fetch(`${apiUrl}/api/v1/devices/${deviceId}/status`);
  if (res.status === 429) {
    // Rate limited — caller should back off and retry
    return { device_id: deviceId, status: "PENDING", fingerprint: "", rateLimited: true };
  }
  if (!res.ok) {
    const detail = await res.text();
    throw new Error(`Status poll failed (${res.status}): ${detail}`);
  }
  return res.json();
}

export async function activateDevice(
  apiUrl: string,
  deviceId: string,
): Promise<ActivateResponse> {
  const res = await fetch(`${apiUrl}/api/v1/devices/${deviceId}/activate`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({}),
  });
  if (!res.ok) {
    const detail = await res.text();
    throw new Error(`Activation failed (${res.status}): ${detail}`);
  }
  return res.json();
}
